
<template>
  <div class="pull-height animated" :class="{'zoomOutUp': isLock}">
		<div class="index" >
			<sidebar class="left"></sidebar>
			<div style="min-width:calc(100vw - 258px);flex: 1;max-width: calc(100vw - 64px); padding-left: 13px;">
				<div class="nav">
					<top class="top"></top>
				</div>
				<div>

							<div class="right">
								<div class="main"  ref="ciicMainBox">
									<div class="router" id="main" ref="ciicMain"  >
										<keep-alive>
											<router-view @toTop="scrolltop"  v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
										</keep-alive>
										<router-view @toTop="scrolltop"  v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
									</div>
								</div>

							</div>
						</div>
			</div>
		</div>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import top from './top/';
import sidebar from './sidebar/';
import store from '@/store';
export default {
  components: {
    top,
    sidebar,
  },
  name: 'index',
  data() {
    return {
      isRouterAlive: true,
      dicts: {}
    };
  },
  created() {

    this.getDicts().then((res) => {
      this.dicts = res.data.data;
      console.log(this.dicts);
      this.$store.commit('SET_DICTS', this.dicts)
    });
  },
  mounted() {
		document.documentElement.style = '';
    // 主题 light-theme/白  dark-theme/黑
    if ( typeof(localStorage.Theme) == "undefined" ){
      localStorage.setItem('Theme', "light-theme");
      localStorage.setItem('Color', "#000000");
    }
    document.getElementsByTagName("body")[0].className=`${localStorage.getItem("Theme")} light-theme2`;
    this.$store.commit('SET_WORKSPACE_RECT',this.$refs.ciicMain);

  },
  computed: mapGetters(['isLock','menu']),
  props: [],
  provide() {
    return {
      reload: this.reload,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 回到顶部
    scrolltop() {
      this.$refs.ciicMainBox.scrollTop = 0
    }
  },
};
</script>

<style lang="scss" scoped>
.index {
  display: flex;
  position: relative;
  background: #fff;
  overflow: hidden;
	height: 100%;
  .left {
    width: 245px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    border-top-right-radius:10px;
    border-bottom-right-radius:10px;
		background: #4278D2;
  }
  .left:before{
    content:"";
    position: absolute;
    top: 0;
    right: 0;
    width: 2px;
    height: 100%;
    z-index: 10;
  }
  .left.is-active:before{
    content:"";
    position: absolute;
    top: 0;
    right: 0;
    width: 0px;
    height: 100%;
    background-color: #7fc4ff;
  }
  .right {
    /*padding-top: 60px;*/
    position: relative;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    flex: 1;
  }
  .main {
    height: calc(100vh - 62px);
    background: #F5F5F5;
    box-sizing: border-box;
    overflow-y: scroll;
    .router {
      padding: 10px;
      padding-left: 0;
      background: #fff;
      min-height: 100%;
      height: auto;
      overflow: hidden;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  .nav {
    box-shadow: 0px 2px 4px 0px rgba(183,183,183,0.15);
  }
  .top {
    /*margin-bottom: 2px;*/
    height: 60px;
    border-radius: 9px 0px 0px 9px;
  }
}

</style>
